// Base URL configuration
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

// API endpoints
const API_ENDPOINTS = {
  // Authentication endpoints
  ESIGNATURE_INITIATE: '/esignature/initiate',
  ESIGNATURE_CALLBACK: '/esignature/callback',
  CHECK_SESSION: '/auth/check-session',

  
  // Esignet OAuth endpoints (NEW)
  ESIGNET_TOKEN: '/esignet/token',
  ESIGNET_SAVE_USER: '/esignet/saveUser',
  
  // Feedback system endpoints
  GET_QUESTIONS: '/qa/getqna',
  SUBMIT_FEEDBACK: '/feedback/create',
  
  // User management
  ADMIN_LOGIN: '/auth/login',
  GET_USER: '/user',
  LOGOUT: '/logout',
};

// Helper function to build full URLs
const buildUrl = (endpoint) => {
  return `${BASE_URL}${endpoint}`;
};

// Export individual URLs
export const URLS = {
  ESIGNATURE_INITIATE: buildUrl(API_ENDPOINTS.ESIGNATURE_INITIATE),
  ESIGNATURE_CALLBACK: buildUrl(API_ENDPOINTS.ESIGNATURE_CALLBACK),
  CHECK_SESSION: buildUrl(API_ENDPOINTS.CHECK_SESSION),
  
  // Esignet URLs (NEW)
  ESIGNET_TOKEN: buildUrl(API_ENDPOINTS.ESIGNET_TOKEN),
  ESIGNET_SAVE_USER: buildUrl(API_ENDPOINTS.ESIGNET_SAVE_USER),
  
  GET_QUESTIONS: buildUrl(API_ENDPOINTS.GET_QUESTIONS),
  SUBMIT_FEEDBACK: buildUrl(API_ENDPOINTS.SUBMIT_FEEDBACK),
  GET_USER: buildUrl(API_ENDPOINTS.GET_USER),
  LOGOUT: buildUrl(API_ENDPOINTS.LOGOUT),
  ADMIN_LOGIN: buildUrl(API_ENDPOINTS.ADMIN_LOGIN)
};

// Export base URL for custom requests
export const API_BASE_URL = BASE_URL;

// Default export for convenience
export default URLS;
